'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var AutoParser =
/*#__PURE__*/
function () {
  function AutoParser() {}

  var _proto = AutoParser.prototype;

  _proto.parse = function parse(response, responseType) {
    if (typeof response === 'string' && responseType === 'json') {
      // PATCH for IE11 omitting request.responseType
      try {
        return JSON.parse(response);
      } catch (e) {
        return {};
      }
    }

    return response;
  };

  return AutoParser;
}();

exports.AutoParser = AutoParser;